// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: 'white',
          borderRadius: 5,
          color: theme.palette.primary.main,
          border: `solid 1px`,
          borderColor: theme.palette.primary.main,
          fontWeight: 'normal',
          maxWidth: "max-content",

          
        },
        arrow: {
          color: theme.palette.grey[isLight ? 800 : 700]
        }
      }
    }
  };
}
